import { useQuery } from "@apollo/client";
import { GridInputs } from "../../../../../components/Functional";
import { FETCH_CONDITION_STATUS } from "../../../../../graphql/query/ConditionStatus";

const Condition = props => {
  const { formik } = props || {};

  const { data: { conditionStatus = [] } = {} } = useQuery(
    FETCH_CONDITION_STATUS,
  );

  const inputs = {
    className:
      "mt-5 grid grid-cols-1 gap-4 sm:grid-cols-2 sm:gap-6 lg:grid-cols-4 lg:gap-16",
    inputs: [
      {
        className: "flex flex-col gap-4",
        inputs: [
          {
            hasOperator: true,
            isMulti: true,
            label: "Condition",
            name: "_condition.statusId",
            options: conditionStatus?.map(status => ({
              label: status.description,
              value: status.id,
            })),
            type: "multi-select",
          },
        ],
      },
    ],
  };

  const gridInputProps = {
    formik,
    ...inputs,
  };

  return <GridInputs {...gridInputProps} />;
};

export default Condition;
